module.exports = __webpack_public_path__ + "img/语音-1.b91e655d.png";